import { useState } from "react";
import Textarea from "@/component/Textarea";
import Empty from "@/sections/Empty";
import Header from "@/sections/Header";
import HotWordGroup from "./HotWordGroup";

interface HotWordGroup {
  title: string;
  content: string;
}

const HotWord = () => {
  const [inputValue, setInputValue] = useState("");
  const [hotWordGroups, setHotWordGroups] = useState<HotWordGroup[]>([]);

  const handleAddHotWordGroup = () => {
    setHotWordGroups([
      ...hotWordGroups,
      {
        title: "热词",
        content: inputValue,
      },
    ]);
  };

  const handleDeleteHotWordGroup = (index: number) => {
    setHotWordGroups(hotWordGroups.filter((_, i) => i !== index));
  };

  return (
    <div className="w-full h-full flex flex-col select-text">
      <Header title="热词管理" />
      <div className="mx-37.5 h-[calc(100%-4rem)] flex-1 flex flex-col items-center overflow-hidden">
        <div className="flex justify-center items-center my-4 ">
          <div className="text-5 color-#337AFF font-500">AI会记热词库</div>
          <div className="mx-2 w-.25 h-4 bg-#DBDEE4"></div>
          <div className="text-5 color-#191D26 font-300">提升识别准确率</div>
        </div>
        <div className="w-full px-6 py-4 rounded-2.5 bg-#fff flex items-center">
          <Textarea
            autoSize
            placeholder="填写多个词用“,”隔开，中文最多10个字符，英文最多30个字符，最多支持128个热词"
            className="w-140.5 lh-5.5 text-mx-tertiary text-3.5 border-0 outline-0 block w-full resize-none text-justify font-normal"
            value={inputValue}
            onChange={(e) => {
              setInputValue(e.target.value);
            }}
            autoFocus
          />
          <div className="bg-#DBDEE4 h-4 w-.25 mx-6"></div>
          <div className="cursor-pointer color-#4981F2 text-3.5 font-400 whitespace-nowrap" onClick={handleAddHotWordGroup}>
            + 添加
          </div>
        </div>

        {hotWordGroups.length ? (
          <div className="flex flex-col flex-1 mt-6 overflow-hidden">
            <div className="flex justify-between h-10 color-#626773 text-3.5">
              <div className="ml-1">自定义热词</div>
              <div className="mr-1">99/128</div>
            </div>
            <div className="flex-1 overflow-scroll">
              {hotWordGroups.map((_hotWordGroup, index) => (
                <HotWordGroup key={index} onDelete={() => handleDeleteHotWordGroup(index)} />
              ))}
            </div>
          </div>
        ) : (
          <div className="w-full flex-1 mt-40">
            <Empty text={"暂无热词记录"} />
          </div>
        )}
      </div>
    </div>
  );
};

export default HotWord;
